import { useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@utils';

export const useUpdateCorrelationId = () => {
  const queryClient = useQueryClient();

  return apiClient.customsNotifications.updateCorrelationId.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['admin-customs-notifications'],
      });
    },
  });
};
